/**
 * Доступна ли тестовая страница /ui-kit.
 *
 * Управляется env-переменной VITE_UI_KIT_PAGE_ALLOW (в CI/CD — чекбокс Jenkins).
 * Единая точка правды по флагу: используется при условной регистрации роута.
 */
export const isUiKitPageAllowed = (): boolean =>
  import.meta.env.VITE_UI_KIT_PAGE_ALLOW === 'true';
